export function ContentWorkspaceChooser({ items, selectedKey, onSelect }) {
  return <div className="grid gap-3 sm:grid-cols-2 xl:grid-cols-4">
    {items.map((item) => <button key={item.key} type="button" onClick={() => onSelect(item.key)} aria-pressed={selectedKey === item.key} className={selectedKey === item.key ? "admin-choice admin-choice-active" : "admin-choice"}><b>{item.label}</b><span className="mt-1 block text-sm text-ink/55">{item.description}</span></button>)}
  </div>;
}
